import { infiniteQueryOptions } from '@tanstack/react-query';
import api from '../services/api';

export interface User {
  userId?: string;
}

interface GetUsersResponse {
  page: number;
  availablePages: number;
  totalSize: number;
  items?: User[];
}

interface GetUsersParams {
  page: number;
  pageSize: number;
  search?: string;
}

const PAGE_SIZE = 50;

export const getUsers = async (idToken: string, schema: string, { page, pageSize, search }: GetUsersParams) => {
  let endpoint = `users?page=${page}&pageSize=${pageSize}&fields=userId&filter=archived:eq:false&filter=loginRequired:eq:true&sort=userId`;
  if (search) {
    endpoint += `&filter=userId:like:${encodeURIComponent(search)}`;
  }

  return api<GetUsersResponse>(endpoint, {
    headers: {
      authorization: `Bearer ${idToken}`,
      'myosh-schema': schema,
    },
  });
};

export const usersInfiniteQueryOptions = (idToken: string, schema: string | undefined, search: string) =>
  infiniteQueryOptions({
    // Interactive picker: surface failures immediately so the UI can show an error instead of
    // silently retrying (a 401 from a stale token would never succeed anyway).
    retry: false,
    queryKey: ['login-control-users', schema, search],
    queryFn: ({ pageParam }) =>
      getUsers(idToken, schema as string, { page: pageParam, pageSize: PAGE_SIZE, search: search || undefined }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => (lastPage.page < lastPage.availablePages ? lastPage.page + 1 : undefined),
  });
